<mat-dialog-content>
    <mat-icon *ngIf="icon" style="margin-right:0.25em;" color="warn">{{icon | lowercase}}</mat-icon>
    <span style="white-space:pre-line;" #test>{{message}}</span><br />
    <mayer-warehouse-selector #selector></mayer-warehouse-selector>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: space-between;">
    <button mat-raised-button color="accent" (click)="onCloseClick(null)" mat-dialog-close
        tabindex="-1">{{cancelButtonText}}</button>
    <button mat-raised-button color="primary" (click)="onCloseClick(selector.value)" mat-dialog-close
        tabindex="-1">{{buttonText}}</button>
</mat-dialog-actions>